<template>
  <div ref="infiniteScrollContainer" @scroll="handleScroll">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import debounce from 'lodash.debounce';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InfiniteScrollContainer',
  props: {
    pause: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleScroll: debounce(function () {
      // @ts-ignore
      const _this = this;

      if (_this.pause) {
        return;
      }

      const container = _this.$el as HTMLElement;
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      const scrollOffset = 150;

      if (scrollBottom <= scrollOffset) {
        _this.$emit('scroll-bottom');
      }
    }, 500)
  }
});
</script>
